import React, { useContext, useEffect, useState, useMemo } from "react";
import { userApiUrl } from "../utils/GetUrl";
import { AuthContext } from "../context/AuthContext";
import NavSub from "../components/NavSub";
import { jsPDF } from "jspdf";
import { UserContext } from "../context/UserContext";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { UserList } from "phosphor-react";
import logo from "../Images/LogoChangeBGRemoved.png";
function AdminPledge() {
  const {
    teamsData,
    setTeamsData, 
    teamNames,
    setTeamNames,
    usersList,
    fetchTeams,
    usersLoading,
  } = useContext(UserContext);
  const [policies, setPolicies] = useState([]);
  const [AcceptancePolicies, setAcceptancePolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [newAgreement, setNewAgreement] = useState({});
  const { userData, token } = useContext(AuthContext);
  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(new Date().getFullYear());
  const [showAcceptanceModal, setShowAcceptanceModal] = useState(false);
  const [currentPolicyId, setCurrentPolicyId] = useState(null);
  const [emp, setEmp] = useState([]);

  const user = userData?.[0];
  const createdBy = user ? `${user.EM_FirstName} ${user.EM_LastName}` : "";
  const create = user ? `${user.EM_ID}` : "";

  const getUserDetails = useMemo(() => {
    return {
      getName: (emId) => {
        if (!usersList || !emId) return "";
        const user = usersList.find((user) => user.EM_ID === emId);
        return user ? `${user.EM_FirstName} ${user.EM_LastName}` : "";
      },
      getEmpId: (emId) => {
        if (!usersList || !emId) return "";
        const user = usersList.find((user) => user.EM_ID === emId);
        return user ? user.EM_EmpID : "";
      },
    };
  }, [usersList]);

  const getMonthDateRange = (year, month) => {
    const start = new Date(year, month, 1, 0, 0, 0);
    const end = new Date(year, month + 1, 0, 23, 59, 59);
    return {
      startDate: formatDateTime(start),
      endDate: formatDateTime(end),
    };
  };

  useEffect(() => {
    if (usersList?.length) {
      const empIds = usersList.map((user) => user.EM_ID);
      setEmp(empIds);
    }
  }, [usersList]);

  const formatDateTime = (date) => {
    const pad = (n) => (n < 10 ? "0" + n : n);
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds()
    )}`;
  };

  const { startDate, endDate } = useMemo(
    () => getMonthDateRange(year, month),
    [month, year]
  );

  const fetchPolicy = async () => {
    try {
      const encodedStart = encodeURIComponent(startDate);
      const encodedEnd = encodeURIComponent(endDate);

      const response = await fetch(`${userApiUrl}/GetPolicy?PolicyId=${27}`);

      if (!response.ok) throw new Error("Failed to fetch policies");

      const data = await response.json();

      setError(null);
    } catch (err) {
      setError("Failed to load policies.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchPolicy2 = async () => {
    try {
      const encodedStart = encodeURIComponent(startDate);
      const encodedEnd = encodeURIComponent(endDate);

      const response = await fetch(
        `${userApiUrl}/GetPolicy?FromDate=${encodedStart}&Todate=${encodedEnd}`
      );

      if (!response.ok) throw new Error("Failed to fetch policies");

      const data = await response.json();
      setPolicies(data);
      setError(null);
    } catch (err) {
      setError("Failed to load policies.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchAcceptance = async () => {
    try {
      if (!token) {
        throw new Error("No authentication token available");
      }

      const encodedStart = encodeURIComponent(startDate);
      const encodedEnd = encodeURIComponent(endDate);

      const response = await fetch(
        `${userApiUrl}/GetPolicyAcceptance?FromDate=${encodedStart}&Todate=${encodedEnd}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error("Session expired. Please log in again.");
        }
        throw new Error("Failed to fetch policies");
      }

      const data = await response.json();
      setAcceptancePolicies(data);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error("Error details:", err);
    } finally {
      setLoading(false);
    }
  };

  const postPolicy = async () => {
    try {
      const { content = "" } = newAgreement;

      // Always use the currently selected month/year from state
      const fromDate = new Date(year, month, 1); // 1st of selected month
      const toDate = new Date(year, month + 1, 0); // Last day of selected month

      const monthYear = fromDate.toLocaleString("default", {
        month: "long",
        year: "numeric",
      });

      const startDateStr = fromDate.toLocaleDateString("en-GB");
      const endDateStr = toDate.toLocaleDateString("en-GB");

      // Determine if this is a future month
      const today = new Date();
      const isFutureMonth = fromDate > today;

      const createdDate = isFutureMonth ? fromDate : today;

      const finalAgreementText = `${content.trim()}`.trim();

      const body = {
        Agreement: finalAgreementText,
        EditBy: create,
        CreatedDateTime: formatDateTime(createdDate),
        Id: "27",
      };

      const response = await fetch(`${userApiUrl}/UpdatePolicy`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) throw new Error("Request failed");

      await fetchPolicy2();
      setIsAddingNew(false);
      setNewAgreement({});
    } catch (err) {
      setError("Failed to create policy.");
      console.error(err);
    }
  };

  const downloadPdf = (policyId) => {
    const policy = policies.find((p) => p.id == policyId);
    if (!policy) return;

    const acceptances = AcceptancePolicies.filter(
      (ap) => ap.policyId == policyId
    );
    const notAcceptedUsers = getNotAcceptedUsers(policyId);

    const addLogo = (doc) => {
      doc.addImage(logo, "PNG", 160, 10, 30, 15);
    };

    const doc = new jsPDF();

    // === Layout constants ===
    const PAGE_TOP_MARGIN = 20;
    const PAGE_BOTTOM_MARGIN = 280;
    const LINE_HEIGHT = 7;
    const SECTION_SPACING = 5;

    const safeText = (text, x = 20, width = 170) => {
      const lines = doc.splitTextToSize(text, width);
      lines.forEach((line) => {
        if (yPosition > PAGE_BOTTOM_MARGIN) {
          doc.addPage();
          addLogo(doc);
          yPosition = PAGE_TOP_MARGIN;
        }
        doc.text(line, x, yPosition);
        yPosition += LINE_HEIGHT;
      });
    };

    const addParagraphSpacing = (amount = SECTION_SPACING) => {
      yPosition += amount;
      if (yPosition > PAGE_BOTTOM_MARGIN) {
        doc.addPage();
        addLogo(doc);
        yPosition = PAGE_TOP_MARGIN;
      }
    };

    const policyDate = new Date(policy.createdDate);
    const monthYearStr = `${String(policyDate.getMonth() + 1).padStart(
      2,
      "0"
    )}-${policyDate.getFullYear()}`;

    // === Summary Page ===
    addLogo(doc);
    doc.setFontSize(18);
    doc.setTextColor(40, 53, 147);
    doc.text("Data Security Pledge Summary", 105, 20, null, null, "center");

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    let yPosition = 35;

    doc.text(`Policy ID: ${policy.id}`, 20, yPosition);
    yPosition += 10;
    doc.text(
      `Created On: ${new Date(policy.createdDate).toLocaleDateString()}`,
      20,
      yPosition
    );
    yPosition += 15;

    doc.setFontSize(14);
    doc.text(
      "Employees Who Accepted This Policy",
      105,
      yPosition,
      null,
      null,
      "center"
    );
    yPosition += 10;

    // === Accepted Users ===
    if (acceptances.length > 0) {
      doc.setFontSize(12);
      acceptances.forEach((acc, index) => {
        const employeeName = getUserDetails.getName(acc.userId);
        const empId = getUserDetails.getEmpId(acc.userId);
        if (yPosition > PAGE_BOTTOM_MARGIN) {
          doc.addPage();
          addLogo(doc);
          yPosition = PAGE_TOP_MARGIN;
        }
        doc.text(`${index + 1}. ${employeeName} (${empId})`, 20, yPosition);
        doc.text(
          `Accepted on: ${new Date(acc.createdDate).toLocaleDateString()}`,
          120,
          yPosition
        );
        yPosition += 10;
      });
    } else {
      doc.text("No employees have accepted this policy yet.", 20, yPosition);
      yPosition += 10;
    }

    // === Not Accepted Users ===
    yPosition += 10;
    if (notAcceptedUsers.length > 0) {
      if (yPosition > PAGE_BOTTOM_MARGIN - 30) {
        doc.addPage();
        addLogo(doc);
        yPosition = PAGE_TOP_MARGIN;
      }

      doc.setFontSize(14);
      doc.text(
        "Employees Who Have Not Accepted This Policy",
        105,
        yPosition,
        null,
        null,
        "center"
      );
      yPosition += 10;

      doc.setFontSize(12);
      notAcceptedUsers.forEach((userId, index) => {
        const employeeName = getUserDetails.getName(userId);
        const empId = getUserDetails.getEmpId(userId);
        if (yPosition > PAGE_BOTTOM_MARGIN) {
          doc.addPage();
          addLogo(doc);
          yPosition = PAGE_TOP_MARGIN;
        }
        doc.text(`${index + 1}. ${employeeName} (${empId})`, 20, yPosition);
        yPosition += 10;
      });
    }

    // === Individual Pledge Pages ===
    acceptances.forEach((acc) => {
      const employeeName = getUserDetails.getName(acc.userId);
      const empId = getUserDetails.getEmpId(acc.userId);

      // === Pledge Page ===
      doc.addPage();
      addLogo(doc);
      doc.setFontSize(18);
      doc.setTextColor(40, 53, 147);
      doc.text("DATA SECURITY PLEDGE", 105, 15, null, null, "center");

      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      yPosition = 30;

      // Replace placeholders in HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = policy.agreement
        .replace(
          /<span style="color: red;">\(Employee Name\)<\/span>/gi,
          employeeName
        )
        .replace(
          /I\s*,?\s*\(?.*?\)?\s*hereby pledge that I will follow the VIEW Synergy Policy/i,
          `I, ${employeeName}, hereby pledge that I will follow the VIEW Synergy Policy`
        )
        .replace(
          /I\s*,?\s*\(?.*?\)?\s*hereby pledge that I will follow the VIEW Group India Policy/i,
          `I, ${employeeName}, hereby pledge that I will follow the VIEW Group India Policy`
        );

      // === Recursive HTML parsing with overflow and page break handling ===
      const processNode = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.replace(/&nbsp;/g, " ").trim();
          if (text) {
            // 🔹 Special rule: move NDA heading to new page
            if (
              text
                .toUpperCase()
                .includes("EMPLOYEE NON-DISCLOSURE AGREEMENT AND SECURITY")
            ) {
              doc.addPage();
              addLogo(doc);
              yPosition = 30;

              doc.setFontSize(12);
              doc.setTextColor(0, 0, 0); // ✅ black color
              doc.setFont(undefined, "bold");
              doc.text(text, 82, yPosition, null, null, "center");
              doc.setFont(undefined, "normal");
              doc.setTextColor(0, 0, 0);
              yPosition += 10;
            } else {
              safeText(text);
            }
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          switch (node.tagName) {
            case "P":
              addParagraphSpacing();
              Array.from(node.childNodes).forEach(processNode);
              break;
            case "BR":
              addParagraphSpacing();
              break;
            case "STRONG":
            case "B":
              doc.setFont(undefined, "bold");
              Array.from(node.childNodes).forEach(processNode);
              doc.setFont(undefined, "normal");
              break;
            case "UL":
            case "OL": {
              const isOrdered = node.tagName === "OL";
              const items = node.querySelectorAll("li");
              items.forEach((item, index) => {
                const prefix = isOrdered ? `${index + 1}. ` : "• ";
                const text =
                  prefix + item.textContent.replace(/&nbsp;/g, " ").trim();
                safeText(text, 25);
              });
              addParagraphSpacing();
              break;
            }
            default:
              Array.from(node.childNodes).forEach(processNode);
          }
        }
      };

      Array.from(tempDiv.childNodes).forEach(processNode);

      // Footer for pledge page
      doc.setFontSize(10);
      doc.setTextColor(100, 100, 100);
      doc.text(
        `Generated on ${new Date().toLocaleDateString()}`,
        105,
        285,
        null,
        null,
        "center"
      );

      // === Signature Page ===
      doc.addPage();
      addLogo(doc);
      doc.setFontSize(14);
      doc.setTextColor(0, 0, 0);
      let sigY = 40;

      doc.text(`Name: ${employeeName}`, 20, sigY);
      sigY += 10;
      doc.text(`Emp ID: ${empId}`, 20, sigY);
      sigY += 20;

      // Manual tick mark (V)
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.line(20, sigY + 2, 22, sigY + 6); // left leg
      doc.line(22, sigY + 6, 26, sigY); // right leg
      doc.setFontSize(12);
      doc.text(
        "I have read and accept the data security policy.",
        30,
        sigY + 5
      );
      sigY += 20;

      doc.setFontSize(12);
      doc.setTextColor(80, 80, 80);
      doc.text(
        "This document is system-generated and does not require a physical signature.",
        20,
        sigY
      );
    });

    // === Save PDF ===
    doc.save(`${monthYearStr} Data Security Pledge Form.pdf`);
  };

  const renderPolicyText = (text) => {
    if (!text) return null;

    // Create a temporary div to parse the HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;

    // Convert to React elements
    const elements = [];
    let currentIndex = 0;

    // Process each child node
    Array.from(tempDiv.childNodes).forEach((node, i) => {
      if (node.nodeType === Node.TEXT_NODE) {
        if (node.textContent.trim()) {
          elements.push(
            <p key={`text-${currentIndex++}`} className="mb-2">
              {node.textContent}
            </p>
          );
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.tagName === "P") {
          const innerElements = [];
          Array.from(node.childNodes).forEach((childNode, j) => {
            if (childNode.nodeType === Node.TEXT_NODE) {
              innerElements.push(childNode.textContent);
            } else if (childNode.nodeType === Node.ELEMENT_NODE) {
              if (childNode.tagName === "STRONG" || childNode.tagName === "B") {
                innerElements.push(
                  <strong key={`strong-${currentIndex}-${j}`}>
                    {childNode.textContent}
                  </strong>
                );
              } else if (
                childNode.tagName === "EM" ||
                childNode.tagName === "I"
              ) {
                innerElements.push(
                  <em key={`em-${currentIndex}-${j}`}>
                    {childNode.textContent}
                  </em>
                );
              } else if (childNode.tagName === "U") {
                innerElements.push(
                  <u key={`u-${currentIndex}-${j}`}>{childNode.textContent}</u>
                );
              } else if (
                childNode.tagName === "SPAN" &&
                childNode.style.color === "red"
              ) {
                innerElements.push(
                  <span
                    key={`span-${currentIndex}-${j}`}
                    className="text-red-500"
                  >
                    {childNode.textContent}
                  </span>
                );
              } else {
                innerElements.push(childNode.textContent);
              }
            }
          });

          elements.push(
            <p key={`p-${currentIndex++}`} className="mb-2">
              {innerElements}
            </p>
          );
        } else if (node.tagName === "UL") {
          const listItems = [];
          Array.from(node.getElementsByTagName("li")).forEach((li, j) => {
            listItems.push(
              <li key={`li-${currentIndex}-${j}`} className="ml-6 list-disc">
                {li.textContent}
              </li>
            );
          });
          elements.push(
            <ul key={`ul-${currentIndex++}`} className="mb-2 ml-6">
              {listItems}
            </ul>
          );
        } else if (node.tagName === "OL") {
          const listItems = [];
          Array.from(node.getElementsByTagName("li")).forEach((li, j) => {
            listItems.push(
              <li key={`li-${currentIndex}-${j}`} className="ml-6 list-decimal">
                {li.textContent}
              </li>
            );
          });
          elements.push(
            <ol key={`ol-${currentIndex++}`} className="mb-2 ml-6">
              {listItems}
            </ol>
          );
        } else if (node.tagName === "STRONG" || node.tagName === "B") {
          elements.push(
            <p
              key={`strong-${currentIndex++}`}
              className="font-bold text-black mb-2"
            >
              {node.textContent}
            </p>
          );
        } else if (node.tagName === "EM" || node.tagName === "I") {
          elements.push(
            <p key={`em-${currentIndex++}`} className="italic mb-2">
              {node.textContent}
            </p>
          );
        } else if (node.tagName === "U") {
          elements.push(
            <p key={`u-${currentIndex++}`} className="underline mb-2">
              {node.textContent}
            </p>
          );
        } else if (node.tagName === "SPAN" && node.style.color === "red") {
          elements.push(
            <p key={`span-${currentIndex++}`} className="text-red-500 mb-2">
              {node.textContent}
            </p>
          );
        } else {
          elements.push(
            <p key={`unknown-${currentIndex++}`} className="mb-2">
              {node.textContent}
            </p>
          );
        }
      }
    });

    return elements;
  };

  const openAcceptanceModal = (policyId) => {
    setCurrentPolicyId(policyId);
    setShowAcceptanceModal(true);
  };

  const closeAcceptanceModal = () => {
    setShowAcceptanceModal(false);
    setCurrentPolicyId(null);
  };

  const getAcceptedUsers = (policyId) => {
    return AcceptancePolicies.filter((ap) => ap.policyId == policyId).map(
      (ap) => ap.userId
    );
  };

  const getNotAcceptedUsers = (policyId) => {
    const acceptedUsers = getAcceptedUsers(policyId);
    return emp.filter((userId) => !acceptedUsers.includes(userId));
  };

  const getLatestPolicyContent = () => {
    if (policies.length === 0) return "";

    // Sort policies by date (newest first)
    const sortedPolicies = [...policies].sort(
      (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
    );

    // Get the latest policy
    const latestPolicy = sortedPolicies[0];

    // Extract just the custom content part (after the standard header)
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = latestPolicy.agreement;

    // Remove the first 3 paragraphs (standard header)
    const paragraphs = tempDiv.querySelectorAll("p");
    if (paragraphs.length > 3) {
      for (let i = 0; i < 3; i++) {
        if (paragraphs[i]) {
          tempDiv.removeChild(paragraphs[i]);
        }
      }
    }

    return tempDiv.innerHTML.trim();
  };

  const handleAddNewPolicy = async () => {
    const today = new Date();
    const selectedMonth = new Date(year, month, 1);
    const isFuture = selectedMonth > today;

    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);

    // Format dates for display (DD/MM/YYYY)
    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    let previousContent = "";

    try {
      // Fetch policy with fixed PolicyId=27
      const response = await fetch(`${userApiUrl}/GetPolicy?PolicyId=${27}`);

      if (!response.ok) throw new Error("Failed to fetch policy");

      const data = await response.json();

      if (data && data.length > 0 && data[0].agreement) {
        const policy = data[0]; // Get the first object from array

        // Extract just the custom content part (after the standard header)
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = policy.agreement;

        // Remove the first 3 paragraphs (standard header)
        const paragraphs = tempDiv.querySelectorAll("p");

        previousContent = tempDiv.innerHTML.trim();
      } else {
      }
    } catch (err) {
      console.error("Failed to fetch policy with ID 27:", err);
      previousContent = "";
    }

    setNewAgreement({
      from: firstDayOfMonth.toISOString().split("T")[0],
      content: previousContent,
      displayStartDate: formatDate(firstDayOfMonth),
      displayEndDate: formatDate(lastDayOfMonth),
      monthYear: selectedMonth.toLocaleString("default", {
        month: "long",
        year: "numeric",
      }),
    });

    setIsAddingNew(true);
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      [{ align: [] }],
      ["blockquote", "code-block"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
  };
  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "color",
    "background",
    "align",
    "script",
    "code-block",
  ];
  useEffect(() => {
    fetchPolicy();
    fetchAcceptance();
    fetchPolicy2();
  }, [startDate, endDate]);

  if (loading)
    return <div className="text-center py-8">Loading policies...</div>;
  if (error)
    return <div className="text-center py-8 text-red-500">{error}</div>;

  return (
    <>
      <NavSub />
      <div className="p-4 max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold" style={{ color: "rgb(59 7 100)" }}>
            Monthly Data Security Pledge
          </h1>
          <div className="flex items-center gap-4">
            <input
              type="month"
              value={`${year}-${String(month + 1).padStart(2, "0")}`}
              onChange={(e) => {
                const [y, m] = e.target.value.split("-");
                setYear(Number(y));
                setMonth(Number(m) - 1);
              }}
              max={`${new Date().getFullYear()}-${String(
                new Date().getMonth() + 1
              ).padStart(2, "0")}`}
              className="p-2 border rounded"
            />

            <button
              onClick={handleAddNewPolicy}
              className="hover:brightness-110 text-white px-4 py-2 rounded-lg shadow-md"
              style={{ backgroundColor: "#50145a" }}
            >
              {policies.length > 0 ? "Edit Policy" : "Create Policy"}
            </button>
          </div>
        </div>
        {isAddingNew && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-3xl max-h-[90vh] flex flex-col">
              {/* {newAgreement.from && (
                <>
                  <h2 className="text-xl font-semibold mb-2 text-center text-[#50145a]">
                    {`Data Security Pledge Form for ${newAgreement.monthYear} (${newAgreement.displayStartDate} to ${newAgreement.displayEndDate})`}
                  </h2>
                  {isFutureMonth && (
                    <div className="bg-yellow-100 border-l-4 border-yellow-500 p-2 mb-4">
                      <p className="text-yellow-700">
                        <strong>Note:</strong> You are creating a pledge for a
                        future month.
                      </p>
                    </div>
                  )}
                  <p className="text-center font-semibold mb-1">
                    MY SOLEMN PLEDGE ON DATA PRIVACY AND INFORMATION SECURITY
                  </p>

                  <p className="text-center text-sm mb-4">
                    I, <span className="text-red-500">(Employee Name)</span>,
                    hereby pledge that I will follow the VIEW Synergy Policy in
                    respect to Data Privacy and Information Security for the
                    period from {newAgreement.displayStartDate} to{" "}
                    {newAgreement.displayEndDate}.
                  </p>
                </>
              )} */}

              <div className="overflow-y-auto flex-1 pr-2 mb-4">
                <ReactQuill
                  theme="snow"
                  value={newAgreement.content || ""}
                  onChange={(content) =>
                    setNewAgreement({
                      ...newAgreement,
                      content: content,
                    })
                  }
                  modules={modules}
                  formats={formats}
                  placeholder="Enter your pledge content here. You can format text, add lists, and use (Employee Name) as placeholder."
                  className="h-64 mb-4"
                />
              </div>

              <div className="flex justify-end gap-4 pt-4">
                <button
                  onClick={() => setIsAddingNew(false)}
                  className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={postPolicy}
                  className="px-4 py-2 text-white rounded hover:bg-indigo-800"
                  style={{ backgroundColor: "#50145a" }}
                  disabled={!newAgreement.from}
                >
                  Save Policy
                </button>
              </div>
            </div>
          </div>
        )}

        {showAcceptanceModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-3xl max-h-[90vh] flex flex-col">
              <h2 className="text-xl font-semibold mb-4 text-[#50145a]">
                Policy Acceptance Details
              </h2>

              <div className="mb-6">
                <h3 className="font-medium text-lg mb-2">Accepted By:</h3>
                <div className="max-h-40 overflow-y-auto border rounded p-2">
                  {getAcceptedUsers(currentPolicyId).length > 0 ? (
                    getAcceptedUsers(currentPolicyId).map((userId) => (
                      <div
                        key={userId}
                        className="py-1 border-b last:border-b-0"
                      >
                        {getUserDetails.getName(userId)} ({getUserDetails.getEmpId(userId)})
                      </div>
                    ))
                  ) : (
                    <div className="text-gray-500">
                      No users have accepted this policy yet
                    </div>
                  )}
                </div>
              </div>

              <div className="mb-6">
                <h3 className="font-medium text-lg mb-2">Not Accepted By:</h3>
                <div className="max-h-40 overflow-y-auto border rounded p-2">
                  {getNotAcceptedUsers(currentPolicyId).length > 0 ? (
                    getNotAcceptedUsers(currentPolicyId).map((userId) => (
                      <div
                        key={userId}
                        className="py-1 border-b last:border-b-0"
                      >
                        {getUserDetails.getName(userId)} (
                        {getUserDetails.getEmpId(userId)})
                      </div>
                    ))
                  ) : (
                    <div className="text-gray-500">
                      All users have accepted this policy
                    </div>
                  )}
                </div>
              </div>

              <div className="mt-auto pt-4 border-t flex justify-end">
                <button
                  onClick={closeAcceptanceModal}
                  className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {policies.length > 0 ? (
          <div className="space-y-6">
            {policies
              .slice()
              .reverse()
              .map((policy) => (
                <div
                  key={policy.id}
                  className="bg-white p-6 rounded-lg shadow-md relative"
                  style={{ borderLeft: "4px solid rgb(59 7 100)" }}
                >
                  <div className="font-medium text-gray-800 mb-4">
                    {renderPolicyText(policy.agreement)}
                  </div>
                  <div className="text-sm text-gray-600 space-y-1 mb-4">
                    <p>
                      {/* <span className="font-medium">Created By:</span>{" "}
                      {getUserDetails.getName(policy.createdBy)} */}
                    </p>
                    {policy.editBy && (
                      <p>
                        <span className="font-medium">Last Edited By:</span>{" "}
                        {policy.editBy}
                      </p>
                    )}
                    <p>
                      <span className="font-medium">Created On:</span>{" "}
                      {policy.createdDate
                        ? new Date(policy.createdDate).toLocaleString()
                        : "N/A"}
                    </p>
                  </div>
                  <div className="flex justify-between items-center mt-4 border-t pt-4">
                    <div className="text-sm text-gray-600">
                      <span className="font-medium">Accepted by:</span>{" "}
                      {
                        AcceptancePolicies.filter(
                          (ap) => ap.policyId == policy.id
                        ).length
                      }{" "}
                      employees
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={() => openAcceptanceModal(policy.id)}
                        className="hover:bg-indigo-700 text-white py-2 px-4 rounded flex items-center gap-2"
                        style={{ backgroundColor: "#50145a" }}
                      >
                        View Acceptance Details
                      </button>
                      <button
                        onClick={() => downloadPdf(policy.id)}
                        style={{ backgroundColor: "#50145a" }}
                        className="hover:bg-indigo-700 text-white py-2 px-4 rounded flex items-center gap-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Download Report
                      </button>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        ) : (
          <div className="bg-white p-6 rounded-lg shadow-md text-center">
            <p className="text-gray-600">
              No policies found for the selected month.
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default AdminPledge;
